<ng-container>
  <div [ngClass]="{'mobile': isMobile, 'vertical-label': verticalLabel, 'horizontal-label': !verticalLabel}" class="autoComplt ds no-subscript">
    <mat-label class="autocomplete-label">{{appStrings.products_productSearch}}</mat-label>
    <div class="container-relative product-search">
      <mat-form-field>
        <input id="productsSearchField" matInput #productsSearchField [matAutocomplete]="productSelector" [formControl]="search"
          placeholder="{{appStrings.products_searchPlaceholder}}" maxlength="25" (input)="searchAutocomplete()">
          <mat-icon matSuffix class="drop-icon">search</mat-icon>
          <mat-autocomplete autoActiveFirstOption #productSelector="matAutocomplete" (optionSelected)="productSelected($event)" class="ds">
            @if (!isLoading && hasResults && resultsText) {
              <div class="results-info">{{resultsText}}</div>
            }
            <cdk-virtual-scroll-viewport class="autocomplete-test-viewport" [hidden]="isLoading || !hasResults" #scrollViewPort
              [ngStyle]="{'height': panelHeight}" itemSize="48">
              @for (foundElements of products; track foundElements) {
                <mat-option role="option" aria-selected="false" [value]="foundElements">
                  <div class="product-option-title">{{foundElements.itemCode}} - <span class="product-option-subtitle">{{foundElements.description}}</span></div>
                </mat-option>
              }
            </cdk-virtual-scroll-viewport>
            @if (!isLoading && loadingMore) {
              <div class="loading-more-text">
                <span>{{appStrings.loading_stillSearching}}</span>
              </div>
            }
            @if (isLoading) {
              <mat-option>
                <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
              </mat-option>
            }
            @if (!hasResults && !isLoading && search.value) {
              <mat-option>{{appStrings.noResults}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </ng-container>